const commonOptimization = {
  jingdouTotal(row) {
    if (row.quantityTotal && row.prizeCount && Number(row.prizeCount) * Number(row.price) > row.quantityTotal) {
      return "";
    } else {
      return row.prizeCount;
    }
  },
  // days为时间间隔的天数，+代表今日往后计算；-代表今日往前计算。minValue为当前时间几分钟后 默认为10分钟
  getDate(days,minValue = 10) {
      //定义今日标准时间;
      let d = new Date();
      // 当前时间
      let currentTime = getYMDHMS(d.getTime() + minValue * 60 * 1000);
      let nowYear = d.getFullYear().toString();//今年
      let nowMonth = timeAdd0((d.getMonth() + 1).toString());//当月
      let nowDay = timeAdd0(d.getDate().toString());//当日
      let now = nowYear + "-" + nowMonth + "-" + nowDay;//今日标准时间; 2020-09-02

      //日期计算;
      let startDate = new Date(Date.parse(now.replace(/-/g, '/'))); //将开始时间由字符串格式转换为日期格式
      let value = startDate.getTime();  //将开始时间转为毫秒
      value += days * (24 * 3600 * 1000); //将天数转换成毫秒后与开始时间相加得到结束时间的毫秒数
      let d2 = new Date(value);    //将得到的毫秒数转换为日期
      let nowYear2 = d2.getFullYear().toString();//今年
      let nowMonth2 = timeAdd0((d2.getMonth() + 1).toString());//当月
      let nowDay2 = timeAdd0(d2.getDate().toString());//当日
      let endDate = nowYear2 + "-" + nowMonth2 + "-" + nowDay2;

      let endDateTime = ''
      let pastTimestamp = new Date(this.$store.state.loginUserInfo.expiredIn).getTime()
      let activTimestamp = new Date(endDate + currentTime.substring(10,currentTime.length)).getTime()
      if(pastTimestamp < activTimestamp) {
        endDateTime = this.$store.state.loginUserInfo.expiredIn
      }else{
        endDateTime = endDate + currentTime.substring(10,currentTime.length)
      }
      return [currentTime,endDateTime];
    }
}
 //补齐十位数;
function timeAdd0(str) {
    if (str.length <= 1) {
        str = '0' + str;
    }
    return str
}
// 时间格式化
function getYMDHMS (timestamp) {
  let time = new Date(timestamp)
  let year = time.getFullYear()
  const month = (time.getMonth() + 1).toString().padStart(2, '0')
  const date = (time.getDate()).toString().padStart(2, '0')
  const hours = (time.getHours()).toString().padStart(2, '0')
  const minute = (time.getMinutes()).toString().padStart(2, '0')
  const second = (time.getSeconds()).toString().padStart(2, '0')

  return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
}

export default commonOptimization